<div class="p-7 w-[400px] max-w-[90vw]">
  <p class="text-[16px] font-bold text-[var(--base-text-alt-dark)] mb-2 m-0">Merge With</p>
  <p class="text-sm text-[var(--base-text-alt-dark)] leading-relaxed">
    Merge selected group(s) to chosen group below.
  </p>
  <form [formGroup]="newGroupForm" class="mt-4">
    <label class="block text-[11px] font-semibold text-[var(--base-text-alt-dark)] uppercase tracking-wide mb-1.5">Group</label>
    <div class="relative">
      <input type="text" [formControl]="groupFilterCtrl"
        [placeholder]="'Type to search or create a group...'"
        (focus)="showGroupDropdown = true"
        (click)="$event.stopPropagation()"
        class="w-full py-2.5 px-3 border-[1.5px] border-[var(--app-border)] rounded-lg text-[13px] font-medium text-[var(--base-text-alt-dark)] bg-white outline-none focus:border-[var(--primary-dark)] placeholder:text-gray-400">
      <!-- Dropdown -->
      <div *ngIf="showGroupDropdown && groupFilterCtrl.value" (click)="$event.stopPropagation()"
        class="absolute top-[calc(100%+4px)] left-0 w-full bg-white rounded-lg shadow-[0_8px_24px_rgba(0,0,0,0.12)] border border-[var(--app-base)] z-[200] overflow-y-auto" style="max-height: 40vh;">
        <div *ngFor="let g of filteredSampleGroups | async" (click)="setSelectedGroup(g); showGroupDropdown = false; groupFilterCtrl.setValue(g.name)"
          class="py-2 px-3.5 text-[13px] font-medium text-[var(--base-text-alt-dark)] cursor-pointer hover:bg-[var(--app-base)]">
          {{g.name}}
        </div>
        <!-- Create option -->
        <div *ngIf="!hasExactMatch()" (click)="createAndSelectGroup()"
          class="py-2.5 px-3.5 text-[13px] font-medium text-[var(--primary-dark)] cursor-pointer hover:bg-[var(--app-base)] border-t border-[var(--app-base)] flex items-center gap-1.5">
          <span class="material-icons text-[16px]">add</span> Create "{{groupFilterCtrl.value}}"
        </div>
      </div>
    </div>
  </form>
  <div class="flex justify-end gap-3 mt-6">
    <button (click)="close()" class="px-5 py-2.5 rounded-lg text-[13px] font-medium text-[var(--base-text-alt-dark)] hover:bg-[var(--app-base)] transition">Cancel</button>
    <button (click)="merge()" [disabled]="!group" class="px-5 py-2.5 rounded-lg text-[13px] font-medium bg-[var(--primary-dark)] text-white hover:opacity-90 transition disabled:opacity-40 disabled:cursor-default">Merge</button>
  </div>
</div>
